export default __webpack_public_path__ + "static/Menu-055500f8ccf1ce1722b25d1c8a4124b3.pdf";